import { Link } from 'react-router-dom'

import errorImg from '/img/error-img.png'

export default function ArticleContainer({ slug, title, img, lead, tag, readmore }) {
  const articleUrl = `/article/${slug}`

  return (
    <article>
      <div className="article__image">
        <h2 className="article__title text-uppercase p-1">
          <Link to={articleUrl}>{title}</Link>
        </h2>
        <Link to={articleUrl}>
          <img
            className={`img-fluid${img ? ' img--zoom' : ''}`}
            src={img || errorImg}
            alt={title}
          />
        </Link>
      </div>

      <div className="article__content">
        <h2 className="article__title mb-3">
          <Link to={articleUrl}>{title}</Link>
        </h2>

        <div className="article__text">
          <div dangerouslySetInnerHTML={{ __html: lead }} />
        </div>

        {tag && (
          <div className="article__badge">
            <ul className="list-unstyled d-flex mb-0">
              <li className="mr-1">
                <span className="badge badge-primary">{tag}</span>
              </li>
            </ul>
          </div>
        )}

        <p className="article__readmore text-right mb-0">
          <Link to={articleUrl} className="f-80">
            {readmore || 'Czytaj więcej...'}
          </Link>
        </p>
      </div>
    </article>
  )
}